import { ExerciseOrSuperset, RoutineExercise } from '../types/Fisiofit/routine';

export const isSuperset = (item: ExerciseOrSuperset): item is RoutineExercise[] => {
  return Array.isArray(item);
};

export const isSingleExercise = (item: ExerciseOrSuperset): item is RoutineExercise => {
  return !Array.isArray(item);
};

// Función para verificar si se puede crear superserie con el ejercicio siguiente
export const canCreateSupersetWithNext = (exercises: ExerciseOrSuperset[], index: number): boolean => {
  return index < exercises.length - 1 && isSingleExercise(exercises[index]) && isSingleExercise(exercises[index + 1]);
};

// Función para verificar si se puede crear superserie con el ejercicio anterior
export const canCreateSupersetWithPrevious = (exercises: ExerciseOrSuperset[], index: number): boolean => {
  return index > 0 && isSingleExercise(exercises[index]) && isSingleExercise(exercises[index - 1]);
};

// Función para verificar si NO se puede crear superserie con el ejercicio siguiente
export const cannotCreateSupersetWithNext = (exercises: ExerciseOrSuperset[], index: number): boolean => {
  return (
    index < exercises.length - 1 &&
    (isSuperset(exercises[index]) || isSuperset(exercises[index + 1])) &&
    !(isSuperset(exercises[index]) && isSuperset(exercises[index + 1]))
  );
};

// Función para verificar si NO se puede crear superserie con el ejercicio anterior
export const cannotCreateSupersetWithPrevious = (exercises: ExerciseOrSuperset[], index: number): boolean => {
  return (
    index > 0 &&
    (isSuperset(exercises[index]) || isSuperset(exercises[index - 1])) &&
    !(isSuperset(exercises[index]) && isSuperset(exercises[index - 1]))
  );
};

export const flattenExercisesForBackend = (exercises: ExerciseOrSuperset[]) => {
  return exercises.map((item) => {
    if (isSuperset(item)) {
      return item.map((exercise) => {
        const { name, imageUrl, videoUrl, exerciseType, ...rest } = exercise;
        return rest;
      });
    }
    const { name, imageUrl, videoUrl, exerciseType, ...rest } = item;
    return rest;
  });
};
